import angular from 'angular'
import root from './root.directive'

export default angular.module('ellipsis.root', []).directive('root', root)
